import React from 'react';
import { Box } from '@wds/box';
import { Button } from '@wds/button';
import { IconBlocks, IconUserPlus } from '@wds/icons';
import { ProgressCircle } from '@wds/progress-circle';
import { Table } from '@wds/table';
import { Typography } from '@wds/typography';

import PropTypes from 'prop-types';

import STRINGS from '../../../constants';
import CardTemplate from '../../../../sma.common/components/react/components/CardTemplate';

const tabStrings = STRINGS.accountSettingsPage.userSectionTab;

const UserSectionTab = (props) => {
	const {
		settings,
		siteInfo,
		handleOpenBecomeApplicantModal,
		handleSetupOrganization,
		renderCustomFields,
		renderOrganizations,
		showCustomFields,
		showBecomeApplicantWarning,
		loadingCustomFields,
		selectedTab,
	} = props;


	return (
		<>
			{settings?.roles && siteInfo.registrationOpen && (
				!settings.roles.includes('applicant')
				|| (siteInfo?.isOrgSite && !settings.roles.includes('organization'))
			) && (
				<CardTemplate
					cardTitle={tabStrings.registration}
					id='registration'
				>
					<Box display='flex' gap={10}>
						{!settings.roles.includes('applicant') && (
							<Box display='flex' flexDirection='column' mx={3}>
								<Box py={2} style={{ maxWidth: '225px' }}>
									<Typography lineHeight={1}>
										{tabStrings.notApplicantTitle}
									</Typography>
								</Box>
								<Box py={2}>
									<Button
										size='md'
										color='success'
										id='become-applicant-button'
										onClick={handleOpenBecomeApplicantModal}
									>
										<IconUserPlus/>
										{tabStrings.becomeApplicant}
									</Button>
								</Box>
							</Box>
						)}
						{siteInfo?.isOrgSite && (
							<Box display='flex' flexDirection='column' mx={3}>
								<Box py={2} style={{ maxWidth: '225px' }}>
									<Typography lineHeight={1}>
										{tabStrings.setupOrganizationTitle}
									</Typography>
								</Box>
								<Box py={2}>
									<Button
										size='md'
										color='success'
										id='setup-organization-button'
										onClick={handleSetupOrganization}
									>
										<IconBlocks/>
										{tabStrings.setupOrganization}
									</Button>
								</Box>
							</Box>
						)}
					</Box>
				</CardTemplate>
			)}
			{(siteInfo?.isOrgSite && settings?.organizations?.length > 0) && (
				<CardTemplate
					cardTitle={tabStrings.organizations}
					id='organizations'
				>
					<Box mx={3}>
						<Table
							density='sm'
							id='sma-account-organizations-grid'
						>
							<Table.Header>
								<Table.Row>
									<Table.HeaderCell
										backgroundColor='accent'
									>
										<Typography
											lineHeight={1}
										>
											{tabStrings.organizationName}
										</Typography>
									</Table.HeaderCell>
									<Table.HeaderCell
										backgroundColor='accent'
										align='center'
									>
										<Typography
											lineHeight={1}
										>
											{tabStrings.organizationRole}
										</Typography>
									</Table.HeaderCell>
								</Table.Row>
							</Table.Header>
							<Table.Body>
								{renderOrganizations()}
							</Table.Body>
						</Table>
					</Box>
				</CardTemplate>
			)}
			{showCustomFields && (
				<CardTemplate
					cardTitle={tabStrings.customFieldsLabel}
					id='site-requested-fields'
				>
					{showBecomeApplicantWarning && (
						<>
							<Typography weight='medium'>
								{STRINGS.becomingApplicantMessage}
							</Typography>
							<Typography weight='medium' variant='caption' color='warning'>
								{STRINGS.navigateAwayWarning}
							</Typography>
						</>
					)}
					{loadingCustomFields ? (
						<Box display='flex' justifyContent='center'>
							<ProgressCircle continuous/>
						</Box>
					) : (
						<Box mx={1}>
							{selectedTab === 'userSectionTab' && (
								renderCustomFields()
							)}
						</Box>
					)}
				</CardTemplate>
			)}
		</>
	);
}

UserSectionTab.propTypes = {
	siteInfo: PropTypes.object.isRequired,
	settings: PropTypes.object.isRequired,
	handleOpenBecomeApplicantModal: PropTypes.func.isRequired,
	handleSetupOrganization: PropTypes.func.isRequired,
	renderCustomFields: PropTypes.func.isRequired,
	renderOrganizations: PropTypes.func.isRequired,
	showCustomFields: PropTypes.bool.isRequired,
	showBecomeApplicantWarning: PropTypes.bool.isRequired,
	loadingCustomFields: PropTypes.bool.isRequired,
	selectedTab: PropTypes.string.isRequired,
}

export default UserSectionTab;